module.exports = __webpack_public_path__ + "files/3580c154317e3e67a3e093c785b80b89.svg";